export const tutorialProgressResourceType = "tutorial_progress" as const;

export const getTutorialProgressPath = (
  companyId: string,
  tutorialId: string
) => {
  return `/companies/${companyId}/tutorial_progress/${tutorialId}`;
};
